<template>
  <custom-container>
    <custom-container id="snapshot-image-scene">
    </custom-container>
    <custom-container class="buy-panel-product-image--container">
      <base-spinner v-show="showSpinner" ></base-spinner>
      <img
        :class="[
          'buy-panel-product-image-model-image',
          {
            'buy-panel-product-image-model-image--apparel': isApparel
          }
        ]"
        src=""
        :alt="pdm?.product_name"
        ref="productImage"
        v-show="!showSpinner"
        @load="hideSpinner"
      />
    </custom-container>
  </custom-container>
</template>

<script>
import baseSpinner from '@/components/Spinner';
import CustomContainer from "@/components/Globals/CustomContainer.vue";
import { external3DScene } from '@/mixins/external3DScene';

export default {
  name: "StaticImageModal",
  data() {
    return {
      showSpinner: true,
    }
  },
  components: {
    baseSpinner,
    CustomContainer
  },
  mixins: [external3DScene],
  methods: {
    /**
     * @function ctaAction
     * Method to be called from parent component from CTA button.
     */
    init3Dscene() {
      this.initExternal3Dscene({domEl: "snapshot-image-scene", snapshotSize: "md", snapshotView: "left", showSnapShot: true});
    },
    hideSpinner() {
      this.showSpinner = false;
    },
    async showProductImage(data) {
      this.$refs.productImage.src=data.fileUrl;
      const cartImageData = await this.initExternal3Dscene({domEl: "snapshot-image-scene", snapshotSize: "lg-pdp-white", snapshotView: "left_pdp", showSnapShot: false});
      this.$store.commit("buyPanel/SET_CART_IMAGE", cartImageData.fileUrl);
    }
  },
  created() {
    this.$eventBus.$on("snapshot-complete", this.showProductImage);
    this.$eventBus.$on("recipe-saved",this.init3Dscene);
  },
  mounted() {
    this.showSpinner = true;
  },
  beforeDestroy() {
    this.$eventBus.$off("snapshot-complete", this.showProductImage);
    this.$eventBus.$off("recipe-saved",this.init3Dscene);
  },
};
</script>
